module.exports = __webpack_public_path__ + "static/btn-left-vector-4d07a07b815fa49c6db28551627f0f54.svg";